import { useUiStore } from '../state/createUiStore';

// This file centralizes all modal-related hooks that are now powered by the uiStore.

// Edit Modal
export const useEditModal = () => {
  const showEditModal = useUiStore((state) => state.showEditModal);
  return { showEditModal };
};

// Character Sheet Modal
export const useCharacterSheetModal = () => {
  const show = useUiStore((state) => state.showCharacterSheetModal);
  return { show };
};

// Other Modals
export const useAddImageModal = () => ({ show: useUiStore((state) => state.showAddImageModal) });
export const useDiceRollerModal = () => ({ show: useUiStore((state) => state.showDiceRollerModal) });
export const useSoundscapeModal = () => ({ show: useUiStore((state) => state.showSoundscapeModal) });
export const useWatchOrderModal = () => ({ show: useUiStore((state) => state.showWatchOrderModal) });
export const useSessionModal = () => ({ show: useUiStore((state) => state.showSessionModal) });
export const useScratchpadModal = () => ({ show: useUiStore((state) => state.showScratchpadModal) });
export const useCampaignLogModal = () => ({ show: useUiStore((state) => state.showCampaignLogModal) });
export const useEncounterModal = () => ({ show: useUiStore((state) => state.showEncounterModal) });
export const useAddManualCombatantModal = () => ({ show: useUiStore((state) => state.showAddManualCombatantModal) });
export const useAddEventModal = () => ({ show: useUiStore((state) => state.showAddEventModal) });
export const useImageSelectModal = () => ({ show: useUiStore((state) => state.showImageSelectModal) });
export const useAddTerrainTypeModal = () => ({ show: useUiStore((state) => state.showAddTerrainTypeModal) });
export const useCreateRegionModal = () => ({ show: useUiStore((state) => state.showCreateRegionModal) });
export const useGridSettingsModal = () => ({ show: useUiStore((state) => state.showGridSettingsModal) });
export const useAddRelationshipModal = () => ({ show: useUiStore((state) => state.showAddRelationshipModal) });